import { render, staticRenderFns } from "./editColumn.vue?vue&type=template&id=1fa3d541&"
import script from "./editColumn.vue?vue&type=script&lang=js&"
export * from "./editColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports